import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "mb-0 text-center text-capitalize-first" }
const _hoisted_3 = { class: "table table-striped border-light align-middle" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "text-secondary" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "small text-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.helper.trans('labels.matching_pay_in_deals')), 1)
    ]),
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1)),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.id_date')), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.type')), 1),
          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.status')), 1),
          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.sum')), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deals.items, (deal) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: deal.id
          }, [
            _createElementVNode("td", null, [
              _createVNode(_component_PayMethodIcon, {
                method: deal.paymentMethod
              }, null, 8, ["method"])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, [
                  _createElementVNode("span", {
                    title: deal.publicId
                  }, _toDisplayString(deal.publicId), 9, _hoisted_9),
                  _cache[1] || (_cache[1] = _createTextVNode()),
                  _createVNode(_component_copy_button, {
                    value: deal.publicId
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("small", _hoisted_10, _toDisplayString(_ctx.dateHelper.format(deal.createdAt)), 1)
              ])
            ]),
            _createElementVNode("td", null, _toDisplayString(_ctx.helper.trans(`direction.${deal.type}`)), 1),
            _createElementVNode("td", {
              class: _normalizeClass({'text-primary': deal.status === _ctx.DealStatus.TRANSFER_CONFIRMED})
            }, [
              _createTextVNode(_toDisplayString(_ctx.helper.trans(`deal_status.${deal.status}`)) + " ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deal.attachments, (attachment) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: attachment.id,
                  href: `${_ctx.api.baseUrl()}/attachments/${attachment.file}`,
                  target: "_blank",
                  type: "button",
                  class: "me-2 text-warning"
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)
                ]), 8, _hoisted_11))
              }), 128))
            ], 2),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.takerSum)) + " ", 1),
                _createVNode(_component_copy_button, {
                  value: deal.takerSum.amount
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.numberFormatter.formatMoney(deal.makerSum)) + " ", 1),
                _createVNode(_component_copy_button, {
                  value: deal.makerSum.amount
                }, null, 8, ["value"])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}